<div class="modal-header">
    <h5 class="modal-title">Kopier normtider til andre medarbejdere</h5>
    <button type="button" class="btn-close" (click)="cancel()"></button>
</div>

<div class="modal-body">

    @if (employees.length === 0) {
        <div class="info-box">
            <p class="text-muted mb-0">Ingen andre aktive medarbejdere at kopiere til.</p>
        </div>
    } @else {
        <div class="select-all-row">
            <label class="checkbox-label">
                <input
                    type="checkbox"
                    [checked]="isAllSelected()"
                    (change)="toggleAll()">
                <span> Vælg alle ({{ employees.length }})</span>
            </label>
        </div>
        <hr>
        <div class="employee-list">
            @for (medarbejder of employees; track medarbejder.cardId) {
                <div class="employee-item">
                    <label class="checkbox-label">
                        <input
                            type="checkbox"
                            [checked]="isSelected(medarbejder.cardId)"
                            (change)="toggleEmployee(medarbejder.cardId)">
                        <span> {{ medarbejder.fornavn }} {{ medarbejder.efternavn }} </span>
                    </label>
                </div>
            }
        </div>

        @if (selectedEmployees.size > 0) {
            <div class="selected-info">
                <small class="text-muted">{{ selectedEmployees.size }} medarbejdere valgt</small>
            </div>
        }
    }

</div>

<div class="modal-footer">
    <button class="btn btn-secondary btn-sm" (click)="cancel()">Annuller</button>
    <button class="btn btn-primary btn-sm"
            (click)="save()"
            [disabled]="selectedEmployees.size === 0">
        Kopier ({{ selectedEmployees.size }})
    </button>
</div>
